import { IMonHocUpdateCongThucRequest } from "../../model/request/category/IMonHocUpdateCongThucRequest"
import { IMonHoc } from "../../model/response/category/IMonHoc"
import { apiClient } from "../apiClient"

export const QUOC_TICH_API = "quoc-tich"
export const quocTichApi = {
    SelectAll: () => apiClient.get(`${QUOC_TICH_API}`),
}